import ReactFlow from 'reactflow';
import { PreviewBadge } from 'assets/js/pages/engage/workflows/components/PreviewBadge';
import { RecenterButton } from 'assets/js/pages/engage/workflows/components/RecenterButton';
import { edgeTypes } from 'assets/js/pages/engage/workflows/utils/edgeTypes';
import { nodeTypes } from 'assets/js/pages/engage/workflows/utils/nodeTypes';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { EdgeTypeEnum } from 'constants/workflows';

const WorkflowDetailsPreview = () => {
    const { nodes, edges, onNodesChange, onEdgesChange } = useReactFlowStore(
        ({ nodes, edges, onNodesChange, onEdgesChange }) => ({
            nodes,
            edges,
            onNodesChange,
            onEdgesChange,
        }),
    );

    return (
        <>
            <div className="absolute left-4 top-4 z-20">
                <PreviewBadge />
            </div>
            <div className="absolute bottom-4 left-4 z-20">
                <RecenterButton />
            </div>
            <ReactFlow
                nodeTypes={nodeTypes}
                edgeTypes={edgeTypes}
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                proOptions={{ hideAttribution: true }}
                preventScrolling={false}
                nodesDraggable={false}
                elementsSelectable={false}
                autoPanOnNodeDrag={false}
                zoomOnDoubleClick={false}
                className="flex-grow"
                deleteKeyCode={null}
                selectionKeyCode={null}
                multiSelectionKeyCode={null}
                defaultEdgeOptions={{ type: EdgeTypeEnum.BASE, focusable: false }}
            />
        </>
    );
};

export { WorkflowDetailsPreview };
